import tinycolor from 'tinycolor2'
import tokens from '@polleverywhere/design-tokens/dist/javascripts/tokens.json'

export function colorToRgba (color) {
  const { r, g, b, a } = tinycolor(color.toString()).toRgb()
  return `rgba(${r},${g},${b},${a})`
}

export function tokenColor (tokenName) {
  if (tokens.props[tokenName]) {
    return tokens.props[tokenName].value
  }
  throw new Error(`Cannot find design token '${tokenName}'`)
}
